'use strict';

$('.notification-button').on('click', function () {
    var date = new Date();
    var cookieName = $(this).data('cookie-name');
    var cookieExpireDate = parseFloat($(this).data('expire-after'), 10);
    var cookieValue = $(this).data('cookie-value');
    date.setTime(date.getTime() + (cookieExpireDate * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + date.toGMTString();
    document.cookie = cookieName + '=' + cookieValue + ';' + expires;
    $('.cookie-notification-wrapper').hide();
});
